/**
 *
 * @param {*} objectName
 * @returns
 */
function isObjectEmpty(objectName) {
	return (
		Object.keys(objectName).length === 0 &&
		objectName.constructor === Object
	);
}

/**
 * Format an array of parameters for use in a URL
 * @param {Array} array The array of parameters
 * @returns {String} The formatted string
 */
function formatParamArray(array) {
	if (array.length > 0) {
		return array.join(',');
	} else {
		return '';
	}
}

/**
 * Remove a parameter from an search parameter array
 * @param {Array} array The array of parameters
 * @param {String} value The value to remove
 * @returns {Array} The updated array
 */
function removeParamFromArray(array, value) {
	const index = array.indexOf(value);
	array.splice(index, 1);
	return array;
}

export { isObjectEmpty, formatParamArray, removeParamFromArray };
